<template>
  <v-col cols="12" sm="11" md="8" lg="6" class="mx-auto text-center font-papyrus">
    <v-card elevation="0" outlined>
      <v-col class="text-center" cols="12" v-if="user != null">
        
        <v-card-title class="green--text">
          <v-icon x-large style="border:1px solid #4CAF50; border-radius:100%; padding:14px;" color="green">mdi-check</v-icon>
          <br>E-mail validé
        </v-card-title>

        <v-divider/>

        <br>

        <v-row>
          <v-col cols="12" class="px-0">
            <v-card-text class="font-papyrus text-left">
              Merci <b>{{ user.name }}</b>,
              votre adresse e-mail a bien été validée.
              <br><br>
              Votre compte courant a été créé. <br>
              Il sera mis en service dès demain matin (4h), lors de la prochaine mise à jour du système.<br>
              Vous pourrez alors accéder à tous les services.
              <br><br>
              En attendant, vous pouvez vous connecter à votre compte, et faire vos premiers pas sur la plateforme !
              <br><br>
              Bienvenue parmi nous !
            </v-card-text>


            <v-card-text class="font-papyrus primary--text text-left">
            <v-divider/>
            <br>
              <h2 class="font-papyrus">Aidez-nous à faire connaitre La Monnaie Pirate !</h2><br>
              <v-btn href="https://www.facebook.com/profile.php?id=100094049551423" target="_blank"
                    x-large color="blue" rounded outlined class="pl-2 mx-1">
                <v-icon x-large>mdi-facebook</v-icon> Lamonnaiepirate
              </v-btn>
              <v-btn href="https://www.youtube.com/@LaMonnaiePirate" target="_blank"
                    x-large color="red" rounded outlined class="pl-2 mx-1">
                <v-icon x-large>mdi-youtube</v-icon> Lamonnaiepirate
              </v-btn>
              <v-btn href="https://discord.gg/aQ34zjvFmC" target="_blank"
                    x-large color="" rounded outlined class="pl-2 mx-1">
                <img src="../../assets/img/homepage/discord-w.png" class="d-block mr-1" height="28" contain/> La Monnaie Pirate
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
       

        <br>

        <v-divider/>

        <br>
        <v-toolbar color="transparent" elevation="0">
          <v-spacer/>
          <v-btn class="my-2 mx-auto" elevation="0" 
                 large color="blue" rounded dark to="/login">
            <b>Se connecter</b>
            <v-icon class="ml-1">mdi-login</v-icon> 
          </v-btn>
        </v-toolbar>

      </v-col>
      <v-col cols="12" v-else>
        <v-btn icon :loading="loading" @click="confirmEmail"><v-icon large>mdi-refresh</v-icon></v-btn> 
        Chargement en cours
      </v-col>
    </v-card>
  </v-col>
</template>

<script>
import axios from "axios"
//import router from '../../router/router'

export default {
  name: "confirm-email",
  components: {
    
  },
  data: function () {
      return {
        user: null,
        loading: true
      };
  },
  mounted: async function(){
    
    await this.confirmEmail()
  },
  methods: {

      async confirmEmail(){
        //if(user != null) return 
        this.loading = true
        console.log('Send /auth/confirm-email/' + this.$route.params.userId + '/' + this.$route.params.emailToken)
        axios.post('/auth/confirm-email/' + this.$route.params.userId + '/' + this.$route.params.emailToken)
             .then((res)=>{ 
                //console.log(res.data)
                if(res.data.error == false){
                  this.user = res.data.user
                }else{
                  console.log('Error after /auth/confirm-email/' + this.$route.params.userId + '/' + this.$route.params.emailToken)
                  this.user = res.data.user
                  //router.push("/login")
                }
                this.loading = false
             })

      },

  },
  computed:{
    
  }
};
</script>
